import { cn } from '@/lib/utils'

type MenuServiceImageProps = {
  src: string
  alt: string
  layout?: 'portrait' | 'landscape'
  className?: string
}

export function MenuServiceImage({
  src,
  alt,
  layout = 'portrait',
  className,
}: MenuServiceImageProps) {
  const isLandscape = layout === 'landscape'

  return (
    <div
      className={cn(
        'menu-service-image relative w-full overflow-hidden rounded-2xl bg-white',
        isLandscape ? 'menu-service-image--landscape' : 'h-full min-h-[100mm]',
        className,
      )}
    >
      <img
        src={src}
        alt={alt}
        className={cn(
          'rounded-2xl object-cover object-center',
          isLandscape ? 'h-full w-full' : 'absolute inset-0 h-full w-full',
        )}
      />
    </div>
  )
}
